import React, { useState } from "react";
import { VStack, Textarea, Button, Box, IconButton } from "@chakra-ui/react";
import { ChatIcon } from "@chakra-ui/icons";

function CommentPopup({ onSave, onClose }) {
    const [isEditing, setIsEditing] = useState(false);
    const [comment, setComment] = useState("");

    const handleSave = () => {
        if (onSave) {
            onSave(comment);
        }
        setComment("");
        setIsEditing(false);
        if (onClose) {
            onClose();
        }
    };

    const handleCancel = () => {
        setIsEditing(false);
        setComment("");
        if (onClose) {
            onClose();
        }
    };

    if (!isEditing) {
        return (
            <IconButton
                icon={<ChatIcon />}
                colorScheme="blue"
                variant="solid"
                size="xs"
                aria-label="Add Comment"
                onClick={() => setIsEditing(true)}
                isRound
            />
        );
    }

    return (
        <VStack align="stretch" spacing={2} minW="250px">
            <Textarea
                placeholder="Type your comment here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                size="sm"
                rows={3}
                autoFocus
            />
            <Box display="flex" justifyContent="flex-end" gap={2}>
                <Button size="xs" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button size="xs" colorScheme="blue" onClick={handleSave}>
                    Save
                </Button>
            </Box>
        </VStack>
    );
}

export default CommentPopup;
